import { Environment } from '@/types/router';

/**
 * Dex audience identifier.
 *
 * Appended to the OIDC scope as `audience:server:client_id:<AuthEnv>`, which makes Dex issue an
 * access token whose `aud` claim names that alias client instead of this app.
 */
export enum AuthEnv {
  qa = 'qa',
  prod = 'prod',
}

/**
 * Maps the deployment environment onto the Dex audience it requests.
 *
 * The audience has to match the stage of the backends we call, since those validate `aud`: the
 * non-prod deployment talks to the QA backends (Ditto QA, Customer Portal QA), so it requests
 * `qa`. `dev` is rejected by Customer Portal QA (AP-1511).
 *
 * Dex only grants an alias to clients with the matching prefix (`trustedPeers: /qa_.*\/`), so
 * this needs the `qa_customer-service_srt-support-app` client — with the `dev_` one Dex fails
 * the sign-in with `invalid_scope`.
 *
 * Unmapped environments resolve to `undefined` — see `getAuthEnv` in `src/environment.ts`.
 */
export const environmentToAuthEnvMap: Readonly<Partial<Record<Environment, AuthEnv>>> = {
  [Environment.local]: AuthEnv.qa,
  [Environment.dev]: AuthEnv.qa,
  [Environment.prod]: AuthEnv.prod,
};
